import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import moment from "moment";
import { ErrorMessage } from "formik";
import { FormControlLabel, FormGroup, Grid, Checkbox } from "@mui/material";

import Field from "../../component/Field";
import Label from "../../component/Label";
import SimpleDate from "../../component/simpleDate";
import SelectField from "../../component/SelectField";
import CalenderButton from "../../component/calenderButton";
import { CommonUtil, LocalStorage, LoginUserDetails } from "../../util/Utils";
import { countryWiseDateFormate, DATE_FORMATS } from "../../util/DateTimeUtils";
import { countryList, TAX_PERCENTAGE, TAX_TYPE } from "../../util/LookupConst";
import "./invoiceAndPayment.scss";

interface InvoicePaymentProps {
  handleDrawerClose?: any;
  handleDrawerOpen?: any;
  setModalOpenSchool?: any;
  values: any;
  handleBlur: any;
  errors: any;
  touched: any;
  setFieldValue: any;
  handleChange: any;
  modeOfPaymentOptions: any;
  promoCodeOptions: any;
  levelDetails: any;
  handleTutionFeesPerMonth: any;
  levelOfAdmissionflag: boolean;
  regkitItemchanged: any;
  courseNameOptions: any;
  registrationTypeOptions: any;
}

const InvoicePayment = (props: InvoicePaymentProps) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    handleTutionFeesPerMonth,
    levelOfAdmissionflag,
    regkitItemchanged,
    courseNameOptions,
    registrationTypeOptions,
  } = props;
  const { setFieldValue, levelDetails } = props;
  const { modeOfPaymentOptions, promoCodeOptions } = props;

  const dateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;
  const { t } = useTranslation();
  const ref = useRef(true);

  const [kitId, setKitId] = useState(
    levelOfAdmissionflag ? "" : values.registrationKitId
  );
  const [regKitItemFlag, setRegkitItemFlag] = useState(false);
  const [discount, setDiscount] = useState(values.discountIfAny);
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  const [invoiceAmountAfterDiscount, setInvoiceAmountAfterDiscount] = useState(0);

  const [tuitionFees, setTuitionFees] = useState(values.tuitionFeesType);
  const [tuitionFeesCheck, setTuitionFeesCheck] = useState(
    values.tuitionFeesChecked
  );
  const [tuitionFeeMonths, setTuitionFeeMonths] = useState<any>(
    values.feeMonth
  );
  const [calculatedTuitionFees, setCalculatedTuitionFees] = useState<any>(0);

const taxType = LocalStorage.get("taxType");

  const [feesPerMonth, setFeesPerMonth] = useState(
    courseNameOptions
      .find((c: any) => c.value === values.courseId)
      .label.indexOf("International") < 0
      ? taxType === TAX_TYPE.NON_GST || taxType === TAX_TYPE.COMPOSITE ? LoginUserDetails.getUserDetails().franchisee.feePerMonthWithTax : LoginUserDetails.getUserDetails().franchisee.feePerMonthWithTax
      : taxType === TAX_TYPE.NON_GST || taxType === TAX_TYPE.COMPOSITE ? LoginUserDetails.getUserDetails().franchisee
          .internationalFeePerMonthWithTax || 0 : LoginUserDetails.getUserDetails().franchisee.internationalFeePerMonthWithTax || 0
  );
  const loginTypeName = useState<string>(
    LoginUserDetails.getUserDetails().franchisee.loginTypeName as string
  );
  //  console.log("loginTypeName: ", loginTypeName);

  const centerTypeId: number =
    LoginUserDetails.getUserDetails().franchisee.centerTypeId;

  const [studentRegistrationInitAmount, setStudentRegistrationInitAmount]: any =
    useState<any>(0);
  const [tuitionFeesTypes, setTuitionFeesTypes] = useState<any>([
    {
      label: "",
      value: "",
    },
    {
      label: "FastTrack",
      value: "FastTrack",
    },
  ]);
  const [promocodeDiscount, setPromocodeDiscount] = useState<any>(
    promoCodeOptions.find((data: any) => data.value === values?.promoCodeId)
  );

  

  const getInitFees = (kitId: any) => {
    let registrationInitialFee;
    if (taxType === TAX_TYPE.NON_GST || taxType === TAX_TYPE.COMPOSITE) {
      registrationInitialFee =
        levelDetails
          ?.find((item: any) => {
            return item.id === parseInt(kitId);
          })
          ?.itemPricing.find((center: any) => {
            return center.centerTypeId === centerTypeId;
          })?.studentRateWithTax || 0;
    } else {
      registrationInitialFee =
        levelDetails
          ?.find((item: any) => {
            return item.id === parseInt(kitId);
          })
          ?.itemPricing.find((center: any) => {
            return center.centerTypeId === centerTypeId;
          })?.studentRateWithTax || 0;
    }
    if(countryList.INDIA===LoginUserDetails.getCountry()){
    setStudentRegistrationInitAmount(registrationInitialFee);
    } else if(countryList.USA===LoginUserDetails.getCountry() && values.oneTimeRegistrationFeeChecked ==="Checked"){
    setStudentRegistrationInitAmount(69);
    }
    else if(countryList.USA===LoginUserDetails.getCountry() && values.oneTimeRegistrationFeeChecked ==="Unchecked"){
    setStudentRegistrationInitAmount(0);
    }
  };

  useEffect(() => {
    if (ref.current) {
      if (levelOfAdmissionflag && !regKitItemFlag) {
        values.registrationKitId = undefined;
        values.totalAmountToBePaid = "";
      }
      // values.feeMonth = [];
      tuitionFeesTypes[0].label = loginTypeName[0];
      tuitionFeesTypes[0].value = loginTypeName[0];
      setTuitionFeesTypes(tuitionFeesTypes);
      getInitFees(kitId);
    }
  }, [loginTypeName]);

  useEffect(() => {
    getInitFees(kitId);
  }, [kitId]);

  //Pre select reg kit
  const [regKitValue, setRegKitValue] = useState("");
  useEffect(() => {
    if (LoginUserDetails.getCountry() === "India") {
      const kitId =
        (levelDetails.length > 0 && levelDetails[0].id) || undefined;
      setRegKitValue(kitId);
      setFieldValue("registrationKitId", kitId);
      values.registrationKitId = kitId;
      setKitId(kitId);
      regkitItemchanged(kitId);
      setRegkitItemFlag(true);
    }
  }, [levelDetails]);

  useEffect(() => {
    if (
      Number(values.registrationTypeId) === registrationTypeOptions[1].id &&
      LoginUserDetails.getCountry() === "India"
    ) {
      handleTuitionFeeChecked({ target: { checked: "Checked" } });
      setTuitionFeesCheck(true);
      values.tuitionFeesChecked = "Checked";
    }
  }, [values.registrationTypeId]);

  // useEffect(() => {
  //   calculateTuitionFees();
  // }, [studentRegistrationInitAmount, discount]);

  const handleTuitionFeeChecked = (e: any) => {
    setTuitionFees(loginTypeName[0]);
    values.tuitionFeesType = loginTypeName[0];

    setTuitionFeesCheck(e.target.checked);
    values.tuitionFeesChecked = e.target.checked ? "Checked" : "Unchecked";

    if (e.target.checked) {
      generateTuitionFeeMonthsLabel();
      values.feeMonth = [];
    } else {
      // Amount without Tuition fee
      let invoiceAmountTmp = (
        studentRegistrationInitAmount - Number(discount)
      ).toFixed(2);
      values.invoiceAmount = invoiceAmountTmp;
      values.feeMonth = [];
      setTuitionFees("");
      setTuitionFeeMonths([]);
      setCalculatedTuitionFees(0);
      //setInvoiceAmount(0);
      // values.totalAmountToBePaid = "";
    }
    handleTutionFeesPerMonth(values);
    values.totalAmountToBePaid = "";
    setFieldValue("totalAmountToBePaid", "");
  };

  const handleTuitionFeeChange = (e: any) => {
    setTuitionFees(e.target.value);
    values.tuitionFeesType = "FastTrack";

    if (e.target.value === loginTypeName[0]) {
      values.tuitionFeesType = loginTypeName[0];
      generateTuitionFeeMonthsLabel();
    }
    setCalculatedTuitionFees(0);

    values.totalAmountToBePaid = "";
    setFieldValue("totalAmountToBePaid", "");
  };

  const generateTuitionFeeMonthsLabel = () => {
    let months: any = [];
    // let selectedMonths: number =
    //   loginTypeName[0] === LOGIN_TYPE.QUARTERLY ? 3 : 1;
    for (let i = -1; i < 12; i++) {
      months.push({
        label: tuitionFeeMonth(i).format(DATE_FORMATS.MMMYY_SPACE),
        value: tuitionFeeMonth(i).format(DATE_FORMATS.MMMMYYYY_HYPHEN),
        selected: false,
      });
    }
    setTuitionFeeMonths(months);
    calculateTuitionFees(0);
  };

  const calculateTuitionFees = (numberOfMonth?: any) => {
    let numberOfSelectedMonths: number = 0;
    if (numberOfMonth) {
      numberOfSelectedMonths = numberOfMonth;
    } else {
      numberOfSelectedMonths =
        tuitionFeeMonths.filter((item: any) => item.selected)?.length || 0;
    }

    let finalTuitionFees = numberOfSelectedMonths * Number(feesPerMonth);
    setCalculatedTuitionFees(finalTuitionFees);

    values.totalAmountToBePaid = "";
    setFieldValue("totalAmountToBePaid", "");
  };

  const tuitionFeeMonth = (index: number) => {
    const d = moment();
    const fm = moment(d).add(index, "M");
    const fmEnd = moment(fm).endOf("month");
    return d.date() !== fm.date() && fm.isSame(fmEnd) ? fm.add(1, "d") : fm;
  };

  const getIndex = (index: number) => {
    if (index === 1) return 4;
    if (index === 2) return 8;
    return index;
  };
const handleOnetimeRegFeeChecked = (e: any) => {
  values.oneTimeRegistrationFeeChecked = e.target.checked ? "Checked" : "Unchecked";
  if(e.target.checked){
    setStudentRegistrationInitAmount(69);
  } else {
    setStudentRegistrationInitAmount(0);
  }
}
  const calculateTuitionFee = (index: number, type?: any) => {
    values.feeMonth = [];
    if (type) {
      for (let i = 0; i < 12; i++) {
        if (i < index) {
          tuitionFeeMonths[i + 1].selected = true;
        } else {
          tuitionFeeMonths[i + 1].selected = false;
        }
      }
    } else {
      tuitionFeeMonths[index].selected = !tuitionFeeMonths[index].selected;
    }
    let tuitionFeeMonthsCopy = CommonUtil.copyObject(tuitionFeeMonths);
    setTuitionFeeMonths(tuitionFeeMonthsCopy);

    calculateTuitionFees();

    values.feeMonth = tuitionFeeMonths
      .filter((item: any) => item.selected)
      .map((item: any) => item.value);
    handleTutionFeesPerMonth(values);
  };

  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    values: any,
    i: number
  ) => {
    levelDetails?.forEach((item: any) => {
      item.selected = false;
    });
    if (event.target.checked) {
      levelDetails[i].selected = true;
    }
    const kitId = event.target.checked ? levelDetails[i]?.id : "";
    setRegKitValue(kitId);
    setFieldValue("registrationKitId", kitId);
    values.registrationKitId = kitId;
    setKitId(kitId);
    regkitItemchanged(kitId);
    setRegkitItemFlag(true);
  };

  const handleDiscountChange = (discount: any) => {
    setDiscount(discount);
    values.discountIfAny = discount;
  };
  // promocode discount calculation
  const promocodeDiscountCalculation = (currentPromocode: any) => {
    let finalFees: number =
      studentRegistrationInitAmount + (calculatedTuitionFees || 0);

    if (
      currentPromocode?.registrationKitDiscountType === "Amount" &&
      studentRegistrationInitAmount > 0
    ) {
      finalFees = finalFees - currentPromocode?.registrationKitDiscount;
    }
    if (
      currentPromocode?.registrationKitDiscountType === "Percentage" &&
      studentRegistrationInitAmount > 0
    ) {
      const discountInPercentage =
        (studentRegistrationInitAmount *
          currentPromocode?.registrationKitDiscount) /
        100;
      finalFees = finalFees - discountInPercentage;
    }
    //tuitionFeeDiscountType
    if (
      currentPromocode?.tuitionFeeDiscountType === "Amount" &&
      calculatedTuitionFees > 0
    ) {
      finalFees = finalFees - currentPromocode?.tuitionFeeDiscount;
    }
    if (
      currentPromocode?.tuitionFeeDiscountType === "Percentage" &&
      calculatedTuitionFees > 0
    ) {
      const discountInPercentage =
        (calculatedTuitionFees * currentPromocode?.tuitionFeeDiscount) / 100;
      finalFees = finalFees - discountInPercentage;
    }
    //Discount if any
    if (Number(discount)) {
      finalFees = finalFees - discount;
    }

    return finalFees;
  };

  // final fee calculation
  useEffect(() => {
    const finalFees = studentRegistrationInitAmount + (calculatedTuitionFees || 0);
    let tax = (finalFees * TAX_PERCENTAGE.INDIA) / 100;
    if (LoginUserDetails.getCountry() === "United States")
      tax = (finalFees * TAX_PERCENTAGE.USA) / 100;

    let finalFeesWithTax;

    if (taxType === TAX_TYPE.NON_GST || taxType === TAX_TYPE.COMPOSITE) {
      finalFeesWithTax = finalFees;
    } else {
      //finalFeesWithTax = finalFees + tax;
      finalFeesWithTax = finalFees;
    }

    values.invoiceAmount = Number(Math.round(finalFeesWithTax).toFixed(2));
    setInvoiceAmount(Number(Math.round(finalFeesWithTax).toFixed(2)));
  }, [
    studentRegistrationInitAmount,
    calculatedTuitionFees,
  ]);

  // final fee calculation
  useEffect(() => {
    const finalFees = promocodeDiscountCalculation(promocodeDiscount);
    let tax = (finalFees * TAX_PERCENTAGE.INDIA) / 100;
    if (LoginUserDetails.getCountry() === "United States")
      tax = (finalFees * TAX_PERCENTAGE.USA) / 100;

    let finalFeesWithTax;

    if (taxType === TAX_TYPE.NON_GST || taxType === TAX_TYPE.COMPOSITE) {
      finalFeesWithTax = finalFees;
    } else {
      //finalFeesWithTax = finalFees + tax;
      finalFeesWithTax = finalFees ;
    }

    //values.invoiceAmount = Number(Math.round(finalFeesWithTax).toFixed(2));
    setInvoiceAmountAfterDiscount(Number(Math.round(finalFeesWithTax).toFixed(2)));
    values.invoiceAmountAfterDiscount = Number(Math.round(finalFeesWithTax).toFixed(2));
  }, [
    studentRegistrationInitAmount,
    promocodeDiscount,
    calculatedTuitionFees,
    discount,
  ]);
  //***** */

  const handlePromocodeChange = (e: any) => {
    const currentPromocode = promoCodeOptions.find(
      (data: any) => data.value === e.target.value
    );
    setPromocodeDiscount(currentPromocode);
  };

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={{ padding: "10px" }}
    >
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <div className="registration-kit">
          {LoginUserDetails.getCountry() === "India" && (
            <>
              <div className="margin-down-10">
                <div className="form-label required">{t("selectKitItem")}</div>
              </div>
              <div style={{ marginBottom: "14px" }}>
                <FormGroup>
                  {levelDetails && levelDetails.length > 0
                    ? levelDetails.map((item: any, i: number) => (
                        <div style={{ width: "100%" }} key={i} >
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="registrationKitId"
                                
                                defaultValue={regKitValue}
                                disabled={
                                  Number(values.registrationTypeId) ===
                                    registrationTypeOptions[1].id &&
                                  courseNameOptions.find(
                                    (course: any) =>
                                      course.value === values.courseId
                                  ).label !== "Global Art" &&
                                  LoginUserDetails.getCountry() === "India"
                                }
                                value={values.registrationKitId}
                                checked={
                                  LoginUserDetails.getCountry() === "India"
                                    ? item.selected
                                    : false
                                }
                                //disabled
                                onChange={(e: any) => {
                                  setFieldValue("totalAmountToBePaid", 0);
                                  handleRadioChange(e, values, i);
                                  setRegkitItemFlag(true);
                                }}
                              />
                            }
                            label={item.itemName}
                          />
                          {(Number(values.registrationTypeId) ===
                            registrationTypeOptions[0].id ||
                            (Number(values.registrationTypeId) ===
                              registrationTypeOptions[1].id &&
                              courseNameOptions.find(
                                (course: any) =>
                                  course.value === values.courseId
                              ).label !== "Global Art")) &&
                            !values?.registrationKitId &&
                            LoginUserDetails.getCountry() === "India" && (
                              <div
                                style={{ color: "red", paddingLeft: "33px" }}
                              >
                                Kit Item is mandatory
                              </div>
                            )}
                        </div>
                      ))
                    : ""}
                </FormGroup>
              </div>
            </>
          )}

{LoginUserDetails.getCountry() === countryList.USA && (
          <div className="us-onetime-registration-fee-control">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                  value={values.oneTimeRegistrationFeeChecked}
                    onClick={(e: any) => handleOnetimeRegFeeChecked(e)}
                  />
                }
                label={
                  <span>
                    {t("One-time Registration Fee - 69.00")}{" "}
                  </span>
                }
              />
            </FormGroup>
          </div>
        )}

          <div className="tuition-fees-control">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      Number(values.registrationTypeId) ===
                        registrationTypeOptions[1].id &&
                      LoginUserDetails.getCountry() === "India"
                    }
                    disabled={
                      Number(values.registrationTypeId) ===
                        registrationTypeOptions[1].id &&
                      LoginUserDetails.getCountry() === "India"
                    }
                    onClick={(e: any) => handleTuitionFeeChecked(e)}
                  />
                }
                label={
                  <span>
                    {t("tuitionFee")}{" "}
                    {Number(values.registrationTypeId) ===
                      registrationTypeOptions[1].id &&
                      LoginUserDetails.getCountry() === "India" && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                  </span>
                }
              />
            </FormGroup>
          </div>
        </div>
        <div className="form-ele-gap">
          <Label required title={t("tuitionFee")} />
          {tuitionFeesCheck === true ? (
            <>
              <SelectField
                name="tuitionFee"
                value={tuitionFees || t("select")}
                onChange={(e: any) => handleTuitionFeeChange(e)}
                inputProps={{ "aria-label": "Without label" }}
                options={tuitionFeesTypes}
              />
              {tuitionFees !== "FastTrack" ? (
                <div>
                  {tuitionFeeMonths && tuitionFeeMonths.length > 0 ? (
                    tuitionFeeMonths.map((item: any, i: number) => {
                      if (i < 3) {
                        return (
                          <div className="flex padding-y-10" key={i}>
                            <CalenderButton
                              selected={tuitionFeeMonths[getIndex(i)].selected}
                              label={tuitionFeeMonths[getIndex(i)].label}
                              onClick={() => calculateTuitionFee(getIndex(i))}
                            />
                            <CalenderButton
                              selected={
                                tuitionFeeMonths[getIndex(i) + 1].selected
                              }
                              label={tuitionFeeMonths[getIndex(i) + 1].label}
                              onClick={() =>
                                calculateTuitionFee(getIndex(i) + 1)
                              }
                            />
                            <CalenderButton
                              selected={
                                tuitionFeeMonths[getIndex(i) + 2].selected
                              }
                              label={tuitionFeeMonths[getIndex(i) + 2].label}
                              onClick={() =>
                                calculateTuitionFee(getIndex(i) + 2)
                              }
                            />
                            <CalenderButton
                              selected={
                                tuitionFeeMonths[getIndex(i) + 3].selected
                              }
                              label={tuitionFeeMonths[getIndex(i) + 3].label}
                              onClick={() =>
                                calculateTuitionFee(getIndex(i) + 3)
                              }
                            />
                          </div>
                        );
                      }
                      return <></>;
                    })
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <>
                  <div className="flex padding-y-10">
                    <CalenderButton
                      selected={
                        tuitionFeeMonths.filter((item: any) => item.selected)
                          .length === 2
                      }
                      label="2 Months Fasttrack"
                      onClick={() => calculateTuitionFee(2, "FastTarck")}
                    />
                    <CalenderButton
                      selected={
                        tuitionFeeMonths.filter((item: any) => item.selected)
                          .length === 3
                      }
                      label="3 Months Fasttrack"
                      onClick={() => calculateTuitionFee(3, "FastTarck")}
                    />
                  </div>
                  <div className="flex padding-y-10">
                    <CalenderButton
                      selected={
                        tuitionFeeMonths.filter((item: any) => item.selected)
                          .length === 4
                      }
                      label="4 Months Fasttrack"
                      onClick={() => calculateTuitionFee(4, "FastTarck")}
                    />
                    <CalenderButton
                      selected={
                        tuitionFeeMonths.filter((item: any) => item.selected)
                          .length === 5
                      }
                      label="5 Months Fasttrack"
                      onClick={() => calculateTuitionFee(5, "FastTarck")}
                    />
                  </div>
                  <div className="flex padding-y-10">
                    <CalenderButton
                      selected={
                        tuitionFeeMonths.filter((item: any) => item.selected)
                          .length === 6
                      }
                      label="6 Months Fasttrack"
                      onClick={() => calculateTuitionFee(6, "FastTarck")}
                    />
                  </div>
                </>
              )}
            </>
          ) : (
            <SelectField
              disabled
              name="tuitionFee"
              value={tuitionFees || t("select")}
              onChange={(e: any) => handleTuitionFeeChange(e)}
              inputProps={{ "aria-label": "Without label" }}
              options={tuitionFeesTypes}
            />
          )}
          {Number(values.registrationTypeId) ===
            registrationTypeOptions[1].id &&
            !tuitionFeesCheck &&
            LoginUserDetails.getCountry() === "India" && (
              <div style={{ color: "red", marginTop: "5px" }}>
                Tuition Fee is mandatory
              </div>
            )}
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <div>
          <div className="autocomplete-form">
            <Label required title={t("modeOfPayment")} />
            <SelectField
              name="modeOfPaymentId"
              value={values.modeOfPaymentId || t("select")}
              onChange={handleChange}
              inputProps={{ "aria-label": "Without label" }}
              options={modeOfPaymentOptions}
            />
          </div>
          <div className="form-ele-gap" style={{ marginBottom: "26px" }}>
            <Label title={t("receiptDate")} />
            <SimpleDate
              className="textFiled"
              name="receiptDate"
              initialValue={values.receiptDate}
              value={values.receiptDate}
              onChange={(e: any) => setFieldValue("receiptDate", e)}
              onBlur={handleBlur}
              format={countryWiseDateFormate()}
              disabled
              helperText={<ErrorMessage name="receiptDate" />}
              error={errors.receiptDate && touched.receiptDate}
            />
          </div>
          <div className="form-ele-gap" style={{ marginBottom: "26px" }}>
            <Label title={t("parentPaidDate")} />
            <SimpleDate
              className="textFiled"
              name="parentPaidDate"
              initialValue={values.parentPaidDate}
              value={values.parentPaidDate}
              onBlur={handleBlur}
              onChange={(e: any) => setFieldValue("parentPaidDate", e)}
              format={countryWiseDateFormate()}
              helperText={<ErrorMessage name="parentPaidDate" />}
              error={errors.parentPaidDate && touched.parentPaidDate}
            />
          </div>
          <div className="form-ele-gap">
            <Label title={t("invoiceAmount")} />
            <Field
              disabled
              className="textFiled"
              placeholder={t("enterHere")}
              name="invoiceAmount"
              value={invoiceAmount}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="invoiceAmount" />}
              error={errors.invoiceAmount && touched.invoiceAmount}
            />
          </div>
          <div className="form-ele-gap autocomplete-form">
            <Label title={t("promoCodeDetails.promoCode")} />
            <SelectField
              name="promoCodeId"
              value={values.promoCodeId || t("select")}
              onChange={(e: any) => {
                handleChange(e);
                handlePromocodeChange(e);
              }}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              options={[{ label: "None", value: null }, ...promoCodeOptions]}
            />
          </div>
          <div
            className="form-ele-gap inherit-number-field"
            style={{ marginBottom: "20px" }}
          >
            <Label title={t("discountIfAny")} />
            <Field
              className="textFiled"
              placeholder={t("enterHere")}
              name="discountIfAny"
              value={discount}
              type="number"
              onChange={(e: any) => {
                handleDiscountChange(e.target.value);
                handleChange(e);
              }}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="discountIfAny" />}
              error={errors.discountIfAny && touched.discountIfAny}
            />
          </div>
          <div
            className="form-ele-gap inherit-number-field"
            style={{ marginBottom: "20px" }}
          >
            <Label title={t("Amount Payable")} />
            <Field
              className="textFiled"
              disabled
              placeholder={t("enterHere")}
              name="invoiceAmountAfterDiscount"
              value={invoiceAmountAfterDiscount.toFixed(2)}
              type="number"
              onChange={
                handleChange
              }
              onBlur={handleBlur}
            />
          </div>
          <div className="form-ele-gap inherit-number-field">
            <div>
              <Label required title={t("Please Enter the Amount Paid")} />
              {/* <span style={{marginLeft:"20px"}}>{invoiceAmountAfterDiscount.toFixed(2)}</span> */}
            </div>
            
            <Field
              disabled={levelOfAdmissionflag && !regKitItemFlag}
              className="textFiled"
              placeholder={t("enterHere")}
              type="number"
              name="totalAmountToBePaid"
              max={invoiceAmountAfterDiscount}
              min={0}
              defaultValue={invoiceAmount}
              value={values.totalAmountToBePaid}
              onChange={handleChange}
              onKeyUp={(e: any) => {
                if (Number(e.target.value) < 0)
                  setFieldValue("totalAmountToBePaid", 0);

                handleTutionFeesPerMonth(values);
              }}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="totalAmountToBePaid" />}
              error={errors.totalAmountToBePaid && touched.totalAmountToBePaid}
            />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default InvoicePayment;